<template>
    <TsBrandSearchResults :show-filters="false" :deals-properties="dealsProperties" hide-title></TsBrandSearchResults> 
</template>

<script setup lang="ts">

const TsBrandSearchResults = defineAsyncComponent(
    () => import('~/components/organisms/TsBrandSearchResults.vue')
);

const dealsProperties = {
  category_name : 'deals',
  category_page_id : '1188'
}
</script>